// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {store} from './services/Store'

/**
 * The scroll behaviour function in the route doesn't seem to be working, so have had to add this
 * afterEach hook to scroll the window back to the top after a new router link is loaded
 */
router.afterEach(() => {
  window.scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  mounted: function () {
    this.$store.dispatch('loadState')
  }
})

window.prerenderReady = true;



// WEBPACK FOOTER //
// ./src/main.js